import { requestTool } from "../tools";

const getTree = () => requestTool.getRequest(process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicCrud/GetActiveTableRecord");

export const layerService = {
    getTree
};

export default layerService;